<template>
  <div>
    <BCard class="border">
      <div>
        <b-form-group label="فایل ضمیمه">
          <b-form-file 
          multiple 
          v-model="newFiles"> </b-form-file>
        </b-form-group>
      </div>
      <div>
        <div class="experiment-files-grid">
          <div
            class="border rounded d-flex align-items-center justify-content-center experiment-file-item position-relative"
            v-for="(file, index) in realValue"
            :key="index"
          >
            <a
              class="d-inline-block border rounded-circle px-2 py-1"
              style="font-size: x-large;"
              :href="file.original_url"
              download
              target="_blank"
            >
              <i class="feather feather-download"></i>
            </a>
            <i
              @click="deleteFilesItem(file.id)"
              class="feather feather-trash text-white btn btn-danger px-1 py-0 experiment-file-delete position-absolute"
            ></i>
          </div>
        </div>
      </div>
    </BCard>
  </div>
</template>
<script>
import ExperimentFilesImpl from "@@/core/components/experiment/ExperimentFiles/ExperimentFilesImpl.js";
export default {
  extends: ExperimentFilesImpl,
};
</script>
<style
  src="@@/core/components/experiment/ExperimentFiles/ExperimentFilesStyle.css"
></style>
